export default __webpack_public_path__ + "static/media/Nirisha.2de4fe97.png";